export default __webpack_public_path__ + "static/media/Department_for_Work_and_Pensions.15130801.svg";